var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { profileUrl } from '@syf-api-library/profile';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import StepView from '../components/StepView';
import useSteps, { StepsProvider } from '../context/steps.context';
export const stepsList = {
    ReasonSelection: [
        {
            nextStep: 'SelectAccount',
            answer: { step: 'ReasonSelection', value: 'damaged-card' }
        },
        {
            nextStep: 'RecognizeTransactions',
            answer: { step: 'ReasonSelection', value: 'never-received' }
        }
    ],
    SelectAccount: [
        {
            nextStep: 'ReviewDamagedCard',
            answer: { step: 'SelectAccount', value: [] }
        }
    ],
    RecognizeTransactions: [{ nextStep: 'SelectCardholder' }],
    SelectCardholder: [
        {
            nextStep: 'ReviewNeverReceived',
            answer: { step: 'SelectCardholder', value: [] }
        }
    ],
    ReviewDamagedCard: [{ nextStep: 'Confirmation' }],
    ReviewNeverReceived: [{ nextStep: 'Confirmation' }],
    Confirmation: [{ nextStep: null }],
    CantVerify: [{ nextStep: null }],
    CantProcess: [{ nextStep: null }],
    CloseConfirmation: [{ nextStep: null }],
    ExitConfirmation: [{ nextStep: null }],
    UnableSubmit: [{ nextStep: null }],
    APIError: [{ nextStep: null }],
    /* Lost Stolen Flow */
    ReasonSelectionLostCard: [
        {
            nextStep: null,
            answer: {
                step: 'ReasonSelectionLostCard',
                value: 'misplaced-card-in-home'
            }
        },
        {
            nextStep: 'WhenLost',
            answer: { step: 'ReasonSelectionLostCard', value: 'lost-card' }
        },
        {
            nextStep: 'WhenLost',
            answer: { step: 'ReasonSelectionLostCard', value: 'stolen-card' }
        }
    ],
    WhenLost: [
        {
            nextStep: 'RecognizeTransactions',
            answer: { step: 'WhenLost', value: '' }
        }
    ],
    TempBlockWithNumber: [{ nextStep: null }],
    ReviewMisplacedCard: [{ nextStep: 'Confirmation' }]
};
const QueryClientWrapper = ({ children }) => {
    const { stepsDispatch } = useSteps();
    const queryClient = useMemo(() => {
        return new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: Infinity,
                    retry: false,
                    refetchOnWindowFocus: false
                }
            },
            queryCache: new QueryCache({
                onError: (error, query) => {
                    const [queryUrl] = query.queryKey;
                    /* NOTE: Don't throw error screen on profile 403 as it's part of step up auth */
                    if (queryUrl === `${profileUrl}-scope` &&
                        error.response.status === 403) {
                        return;
                    }
                    /*
                     * NOTE: Don't throw error screen on replace card 422 as it's what the API returns when there
                     * are no eligible cards for replacement
                     */
                    if (queryUrl === 'v1/credit/cards/replace' &&
                        error.response.status === 422) {
                        stepsDispatch({ type: 'updateStep', payload: 'CantProcess' });
                        return;
                    }
                    stepsDispatch({ type: 'updateStep', payload: 'APIError' });
                }
            })
        });
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);
    return (_jsx(QueryClientProvider, Object.assign({ client: queryClient }, { children: children })));
};
const firstStepMap = {
    replacement: 'ReasonSelection',
    'lost-stolen': 'ReasonSelectionLostCard'
};
const ReplacementLostStolen = (_a) => {
    var { flow, onClose, handleProfileClick } = _a, props = __rest(_a, ["flow", "onClose", "handleProfileClick"]);
    const firstStep = firstStepMap[flow];
    const initialStepsState = {
        flow,
        stepsList,
        activeStep: firstStep,
        previousSteps: [],
        isRequestLoading: false,
        onCancelFlow: onClose,
        handleProfileClick: (account) => handleProfileClick(account),
        onRequest: () => undefined,
        answers: [],
        error: false
    };
    return (_jsx(StepsProvider, Object.assign({ initialStepsState: initialStepsState }, { children: _jsx(QueryClientWrapper, { children: _jsx(StepView, Object.assign({}, props)) }) })));
};
export default ReplacementLostStolen;
//# sourceMappingURL=index.js.map